import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "title-container"
};

var _hoisted_2 = /*#__PURE__*/_createTextVNode("接口文档");

var _hoisted_3 = /*#__PURE__*/_createTextVNode("后台管理");

var _hoisted_4 = /*#__PURE__*/_createTextVNode("退出登录");

var _hoisted_5 = /*#__PURE__*/_createTextVNode("登录");

var _hoisted_6 = /*#__PURE__*/_createTextVNode("注册");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_button = _resolveComponent("el-button");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_button, {
    type: "success",
    size: "small",
    plain: "",
    onClick: $setup.handlerApiDoc
  }, {
    default: _withCtx(function () {
      return [_hoisted_2];
    }),
    _: 1
  }, 8, ["onClick"]), _withDirectives(_createVNode(_component_el_button, {
    type: "primary",
    size: "small",
    plain: "",
    onClick: $setup.handlerAdmin
  }, {
    default: _withCtx(function () {
      return [_hoisted_3];
    }),
    _: 1
  }, 8, ["onClick"]), [[_vShow, $setup.loginState]]), _withDirectives(_createVNode(_component_el_button, {
    type: "danger",
    size: "small",
    plain: "",
    onClick: $setup.handlerLoginOut
  }, {
    default: _withCtx(function () {
      return [_hoisted_4];
    }),
    _: 1
  }, 8, ["onClick"]), [[_vShow, $setup.loginState]]), _withDirectives(_createVNode(_component_el_button, {
    type: "primary",
    size: "small",
    plain: "",
    onClick: $setup.handlerLogin
  }, {
    default: _withCtx(function () {
      return [_hoisted_5];
    }),
    _: 1
  }, 8, ["onClick"]), [[_vShow, !$setup.loginState]]), _withDirectives(_createVNode(_component_el_button, {
    type: "danger",
    size: "small",
    plain: "",
    onClick: $setup.handlerRegister
  }, {
    default: _withCtx(function () {
      return [_hoisted_6];
    }),
    _: 1
  }, 8, ["onClick"]), [[_vShow, !$setup.loginState]])]);
}